function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg220Uzbekistn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.007,
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 181.793
  }), /*#__PURE__*/React.createElement("rect", {
    y: 330.207,
    style: {
      fill: "#6DA544"
    },
    width: 512,
    height: 181.793
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M173.389,115.322c0-19.617,13.787-36.006,32.198-40.027c-2.829-0.618-5.766-0.954-8.781-0.954   c-22.634,0.001-40.98,18.347-40.98,40.981s18.346,40.98,40.98,40.98c3.016,0,5.951-0.335,8.781-0.954   C187.176,151.328,173.389,134.94,173.389,115.322z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "229.808,133.95 232.583,142.487 241.56,142.487 234.297,147.765 237.072,156.302    229.808,151.027 222.545,156.302 225.32,147.765 218.056,142.487 227.034,142.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "258.462,133.95 261.236,142.487 270.214,142.487 262.951,147.765 265.725,156.302    258.462,151.027 251.198,156.302 253.973,147.765 246.711,142.487 255.687,142.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.115,133.95 289.89,142.487 298.867,142.487 291.604,147.765 294.379,156.302    287.115,151.027 279.853,156.302 282.626,147.765 275.364,142.487 284.341,142.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "315.768,133.95 318.543,142.487 327.521,142.487 320.257,147.765 323.032,156.302    315.768,151.027 308.506,156.302 311.28,147.765 304.017,142.487 312.994,142.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "344.422,133.95 347.196,142.487 356.174,142.487 348.911,147.765 351.685,156.302    344.422,151.027 337.159,156.302 339.933,147.765 332.671,142.487 341.648,142.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "258.462,104.146 261.236,112.683 270.214,112.683 262.951,117.96 265.725,126.498    258.462,121.222 251.198,126.498 253.973,117.96 246.711,112.683 255.687,112.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.115,104.146 289.89,112.683 298.867,112.683 291.604,117.96 294.379,126.498    287.115,121.222 279.853,126.498 282.626,117.96 275.364,112.683 284.341,112.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "315.768,104.146 318.543,112.683 327.521,112.683 320.257,117.96 323.032,126.498    315.768,121.222 308.506,126.498 311.28,117.96 304.017,112.683 312.994,112.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "344.422,104.146 347.196,112.683 356.174,112.683 348.911,117.96 351.685,126.498    344.422,121.222 337.159,126.498 339.933,117.96 332.671,112.683 341.648,112.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.115,74.342 289.89,82.881 298.867,82.881 291.604,88.156 294.379,96.696    287.115,91.418 279.853,96.696 282.626,88.156 275.364,82.881 284.341,82.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "315.768,74.342 318.543,82.881 327.521,82.881 320.257,88.156 323.032,96.696    315.768,91.418 308.506,96.696 311.28,88.156 304.017,82.881 312.994,82.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "344.422,74.342 347.196,82.881 356.174,82.881 348.911,88.156 351.685,96.696    344.422,91.418 337.159,96.696 339.933,88.156 332.671,82.881 341.648,82.881  "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.348,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 111.304
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg220Uzbekistn);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };